import React from "react";

const INDUSTRIES = [
  {
    id: "01",
    title: "Banking, Financial Services & Insurance",
    desc: "14 pillars of security and compliance — GDPR, PCI DSS, ISO 27001, RBI, and more — built into every BFSI engagement.",
    href: "/industries/bfsi-security-excellence.html",
    cta: "Read: Secure. Compliant. Trusted.",
    disabled: false,
  },
  {
    id: "02",
    title: "Healthcare — UK & US",
    desc: "HIPAA, NHS DSPT, GDPR, and FDA-aligned architecture for healthcare platforms that handle real patient data.",
    href: "/industries/healthcare-security-excellence.html",
    cta: "Read: Secure. Compliant. Trusted.",
    disabled: false,
  },
];

export default function Industries() {
  return (
    <section id="industries" className="section" style={{ background: "var(--paper-dim)" }}>
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-7">
            <div className="eyebrow mb-3">Industries we serve</div>
            <h2 className="display-font mb-3" style={{ fontSize: "2.2rem", fontWeight: 600, color: "var(--navy-deep)" }}>
              Built for the industries where trust is non-negotiable
            </h2>
          </div>
        </div>
        <div className="row g-4">
          {INDUSTRIES.map((ind) => (
            <div className="col-md-6" key={ind.id}>
              <div className="card-system h-100 d-flex flex-column">
                <div className="node-id mb-3">IND / {ind.id}</div>
                <h3 className="display-font mb-3" style={{ fontSize: "1.2rem", fontWeight: 600, color: "var(--navy-deep)" }}>
                  {ind.title}
                </h3>
                <p style={{ color: "#4b5b63", lineHeight: 1.65, fontSize: "0.95rem", flexGrow: 1 }}>
                  {ind.desc}
                </p>
                {ind.disabled ? (
                  <span className="mono-label" style={{ color: "#9aa7ad" }}>{ind.cta}</span>
                ) : (
                  <a
                    href={ind.href}
                    className="btn-outline-brand text-decoration-none align-self-start"
                    style={{ borderColor: "var(--navy-deep)", color: "var(--navy-deep)" }}
                  >
                    {ind.cta}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
